export default __webpack_public_path__ + "static/media/ContactGenious.971dbff7ec100031d92903c82e7d9929.webp";